import { IRawStyle } from "@fluentui/react";
import React from "react";
import { ContentSection, GridRow, GridColumn, LabeledText, ButtonRenderProps } from "sprint-common-web";

import { AspectRatiosDataProvider } from "../../../../../common/data/lookup-data-providers/AspectRatiosDataProvider";
import { AspectTypesDataProvider } from "../../../../../common/data/lookup-data-providers/AspectTypesDataProvider";
import { OnPremVideoTechnical } from "../../OnPremAssetDetails";
import {
    EditOnPremVideoAssetTechnicalAside,
    EditOnPremVideoAssetTechnicalAsideProps
} from "./edit/EditOnPremVideoTechnicalButtonAside";

interface OnPremVideoTechnicalSectionProps {
    technical: OnPremVideoTechnical;
    isLoading: boolean;
    style?: IRawStyle;
}

export const OnPremVideoTechnicalSection: React.FunctionComponent<OnPremVideoTechnicalSectionProps> = (
    props: OnPremVideoTechnicalSectionProps
) => {
    const { technical, isLoading } = props;

    const editTechnicalButton: ButtonRenderProps<EditOnPremVideoAssetTechnicalAsideProps> = {
        isLabeled: true,
        render: EditOnPremVideoAssetTechnicalAside
    };

    return (
        <AspectTypesDataProvider>
            <AspectRatiosDataProvider>
                <ContentSection
                    header="Technical"
                    isLoading={isLoading}
                    buttons={[editTechnicalButton]}
                    style={props.style}
                >
                    <GridRow>
                        <GridColumn sm={3}>
                            <LabeledText label="Duration" value={technical.duration} testId="Duration" />
                            <LabeledText
                                label="Encoding"
                                value={technical.encoding ? "Prores" : "Not Prores"}
                                testId="Encoding"
                            />
                        </GridColumn>
                        <GridColumn sm={3}>
                            <LabeledText label="Bitrate" value={technical.videoBitRate} testId="bit-rate-field" />
                            <LabeledText label="Resolution" value={technical.resolution} testId="resolution-field" />
                        </GridColumn>
                        <GridColumn sm={3}>
                            <LabeledText
                                label="Aspect ratio"
                                value={technical.aspectRatio?.name ?? "-"}
                                testId="aspect-ratio-field"
                            />
                            <LabeledText label="Framerate" value={technical.framerate} testId="framerate-field" />
                        </GridColumn>
                        <GridColumn sm={3}>
                            <LabeledText
                                label="Aspect type"
                                value={technical.aspectType?.name ?? "-"}
                                testId="aspect-type-field"
                            />
                            <LabeledText label="Standard" value={technical.standard?.name} testId="standard-field" />
                        </GridColumn>
                    </GridRow>
                </ContentSection>
            </AspectRatiosDataProvider>
        </AspectTypesDataProvider>
    );
};
